import React from "react";
import Select from "react-select";

export const MachineTyepeOptions = [
  { value: "Flex Conveyer", label: "Flex Conveyer" },
  { value: "Electric Pallet Jack", label: "Electric Pallet Jack" },
];

const MachineTypeSelect = ({ label, value, setValue, showImportant = true }) => {
  const handleChange = (selected) => {
    if (setValue && typeof setValue === "function") {
      setValue(selected ? selected.value : null);
    }
  };

  return (
    <div>
      {label && (
        <label className="mb-2">
          <p>
            {label} {showImportant && <span>*</span>}
          </p>
        </label>
      )}
      <Select
        theme={(theme) => ({
          ...theme,
          borderRadius: 5,
          colors: {
            ...theme.colors,
            primary50: "#ca373c50",
            primary25: "#ca373c50",
            primary: "#ca373c70",
            danger: "#000000",
            neutral30: "#00000050",
          },
        })}
        isSearchable={false}
        value={MachineTyepeOptions.find((opt) => opt.value === value) || null}
        options={MachineTyepeOptions}
        onChange={handleChange}
      />
    </div>
  );
};

export default MachineTypeSelect;
